<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-main>
      <div class="zj-layout-main-content scrollable">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem" style="max-width:120rem;">
          <el-form-item label></el-form-item>
          <el-form-item label="队伍名称" prop="teamName">
            <el-input v-model="ruleForm.teamName" style="width:98rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="队伍归属" prop="teamBelong" style="display:inline-block;">
            <el-radio-group
              v-model="ruleForm.teamBelong"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
            >
              <el-radio
                v-for="item in options4"
                :key="item.code"
                :label="item.code"
                :value="item.code"
              >{{item.value}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="队伍类型" prop="teamType" style="display:inline-block;">
            <el-select
              v-model="ruleForm.teamType"
              placeholder="请选择队伍类型"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
            >
              <el-option
                v-for="item in options"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否具有资质" prop="qualifiedFlag" style="display:inline-block;">
            <el-select
              v-model="ruleForm.qualifiedFlag"
              placeholder="请选择是否具有资质"
              v-bind:disabled="IsEdit"
              style="width:40rem;"
            >
              <el-option
                v-for="item in options5"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="成立时间" prop="foundTime" style="display:inline-block;">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.foundTime"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
              format="yyyy-MM-dd HH:mm:ss" 
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="详细地址" prop="address" style="display:inline-block;">
            <el-input v-model="ruleForm.address" style="width:98rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="经度" prop="longitude" style="display:inline-block;">
            <el-input v-model="ruleForm.longitude" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="纬度" prop="latitude" style="display:inline-block;">
            <el-input v-model="ruleForm.latitude" style="width:35rem;" v-bind:disabled="IsEdit"></el-input>
            <ZjLngLatSelect
              :point_lat="ruleForm.latitude"
              :point_lng="ruleForm.longitude"
              :disabled="IsEdit"
              @onGotLngLat="onGotLngLat"
              style="margin-left:0.5rem"
            ></ZjLngLatSelect>
          </el-form-item>
          <el-form-item label="队伍等级" prop="teamLevel" style="display:inline-block;">
            <el-select
              v-model="ruleForm.teamLevel"
              style="width:40rem;"
              placeholder="请选择队伍等级"
              v-bind:disabled="IsEdit"
            >
              <el-option
                v-for="item in options2"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务区域" prop="serviceArea" style="display:inline-block;">
            <el-input v-model="ruleForm.serviceArea" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="总人数" prop="totalNum" style="display:inline-block;">
            <el-input v-model="ruleForm.totalNum" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="指战人数" prop="commandNum" style="display:inline-block;">
            <el-input v-model="ruleForm.commandNum" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="擅长事故类型" prop="goodAccidentsType" style="display:inline-block;">
            <el-select
              v-model="ruleForm.goodAccidentsType"
              style="width:40rem;"
              placeholder="请选择擅长事故类型"
              v-bind:disabled="IsEdit"
            >
              <el-option
                v-for="item in options3"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆数" prop="vehicleNum" style="display:inline-block;">
            <el-input v-model="ruleForm.vehicleNum" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="专长描述" prop="expertiseDesc">
            <el-input
              type="textarea"
              style="width:98rem;"
              v-model="ruleForm.expertiseDesc"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="主要装备描述" prop="mainEquipmentDesc">
            <el-input
              type="textarea"
              style="width:98rem;"
              v-model="ruleForm.mainEquipmentDesc"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="responsiblePerson" style="display:inline-block;">
            <el-input v-model="ruleForm.responsiblePerson" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="负责人移动电话" prop="mobileNo" style="display:inline-block;">
            <el-input
              v-model="ruleForm.mobileNo"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人固定电话" prop="fixedTel" style="display:inline-block;">
            <el-input v-model="ruleForm.fixedTel" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="应急值班电话" prop="dutyTel" style="display:inline-block;">
            <el-input v-model="ruleForm.dutyTel" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="分管领导" prop="chargeLeader" style="display:inline-block;">
            <el-input v-model="ruleForm.chargeLeader" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="分管领导移动电话" prop="leaderMobile" style="display:inline-block;">
            <el-input
              v-model="ruleForm.leaderMobile"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="分管领导固定电话" prop="leaderFixedTel" style="display:inline-block;">
            <el-input v-model="ruleForm.leaderFixedTel" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark" style="display:inline-block;">
            <el-input
              type="textarea"
              style="width:98rem;"
              v-model="ruleForm.remark"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <div style="width:116rem; text-align:center;margin:1rem 1rem;padding-left:16rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">保存</el-button>
        <el-button @click="resetForm()" v-show="IsEdit==false">重置</el-button>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import ZJApp from '../../../../../app';
const utils = ZJApp.ZJUtils;

import { getDictionary } from "@/api/src/emergency_common";
import { save, update, detail } from "@/api/src/emergency_resourcesTeam";
export default {
  name: "ZjResourcesTeaminfo",
  controller: "EmergencyResource",
  action: "ResourcesTeaminfo",
  props: {
    query: {
      type: String,
      id: String
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中',
      ruleForm: {
        teamName: "",
        teamBelong: "",
        teamType: "",
        qualifiedFlag: "",
        foundTime: null,
        address: "",
        longitude: "",
        latitude: "",
        teamLevel: "",
        serviceArea: "",
        totalNum: 0,
        commandNum: 0,
        goodAccidentsType: "",
        vehicleNum: 0,
        expertiseDesc: "",
        mainEquipmentDesc: "",
        responsiblePerson: "",
        mobileNo: "",
        fixedTel: "",
        dutyTel: "",
        chargeLeader: "",
        leaderMobile: "",
        leaderFixedTel: "",
        remark: ""
      },
      options: [],
      options2: [],
      options3: [],
      options4: [],
      options5: [],
      rules: {
        teamName: [
          { required: true, message: "请输入队伍名称", trigger: "blur" }
        ],
        teamBelong: [
          { required: true, message: "请选择队伍归属", trigger: "charge" }
        ],
        qualifiedFlag: [
          { required: true, message: "请选择是否具有资质", trigger: "charge" }
        ],
        address: [{ required: true, message: "请选择地址", trigger: "blur" }],
        longitude: [
          { required: true, message: "请选择经纬度", trigger: "blur" }
        ],
        latitude: [
          { required: true, message: "请选择经纬度", trigger: "blur" }
        ],
        IsEdit: false
        //desc: [{ required: true, message: "请填写备注", trigger: "blur" }]
      }
    };
  },
  created: function() {
    this.basedatabind()
    .then(()=>{
      this.search();
    });
    this.IsEdit = this.query.type == "edit" ? false : true;
  },
  mounted: function() {},
  watch: {
    query: {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        this.ruleForm = {
          teamName: "",
          teamBelong: "",
          teamType: "",
          qualifiedFlag: "",
          foundTime: null,
          address: "",
          longitude: "",
          latitude: "",
          teamLevel: "",
          serviceArea: "",
          totalNum: 0,
          commandNum: 0,
          goodAccidentsType: "",
          vehicleNum: 0,
          expertiseDesc: "",
          mainEquipmentDesc: "",
          responsiblePerson: "",
          mobileNo: "",
          fixedTel: "",
          dutyTel: "",
          chargeLeader: "",
          leaderMobile: "",
          leaderFixedTel: "",
          remark: ""
        };
        this.search();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';
      return utils.waitAll([
        getDictionary('emergency_team_good_accidents'),
        getDictionary('emergency_team_level'),
        getDictionary('emergency_team_type'),
        getDictionary('emergency_team_belong'),
        getDictionary('yes_no'),
      ])
      .then(r => {
        //擅长事故类型
        this.options3 = r[0].data.records;

        //队伍等级
        this.options2 = r[1].data.records;

        //队伍类型
        this.options = r[2].data.records;

        //队伍归属
        this.options4 = r[3].data.records;
        //是否具有资质
        this.options5 = r[4].data.records;

        this.loading = false;

        return r;
      })
      .catch(e => {
        console.error(e);
        this.loading = false;
      });
    },
    search() {
      let { id } = this.query;
      if (id != null && id != "") {
        this.loading = true;
        this.loadingText = '加载中...';
        detail( id )
          .then(r => {
            r = r.data;
            this.ruleForm = r;
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      }
    },
    onGotLngLat(obj) {
      this.ruleForm.latitude = obj.lat;
      this.ruleForm.longitude = obj.lng;
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //重置
    resetForm() {
      //this.ruleForm = formName;
      this.ruleForm = {
          teamName: "",
          teamBelong: "",
          teamType: "",
          qualifiedFlag: "",
          foundTime: null,
          address: "",
          longitude: "",
          latitude: "",
          teamLevel: "",
          serviceArea: "",
          totalNum: 0,
          commandNum: 0,
          goodAccidentsType: "",
          vehicleNum: 0,
          expertiseDesc: "",
          mainEquipmentDesc: "",
          responsiblePerson: "",
          mobileNo: "",
          fixedTel: "",
          dutyTel: "",
          chargeLeader: "",
          leaderMobile: "",
          leaderFixedTel: "",
          remark: ""
        };
      //this.$refs[formName].resetFields();
      this.query.id = null;
    },
    save() {
      this.ruleForm.longitude = parseFloat(this.ruleForm.longitude); //
      this.ruleForm.latitude = parseFloat(this.ruleForm.latitude);
      this.ruleForm.qualifiedFlag = parseInt(
        this.ruleForm.qualifiedFlag
      );
      this.ruleForm.commandNum = parseInt(this.ruleForm.commandNum);
      this.ruleForm.vehicleNum = parseInt(this.ruleForm.vehicleNum);
      this.ruleForm.totalNum = parseInt(this.ruleForm.totalNum);
      this.ruleForm.teamBelong = this.ruleForm.teamBelong.toString();
      if (this.query.id == null || this.query.id == "") {
        this.loading = true;
        this.loadingText = '保存中...';
        save(this.ruleForm)
          .then(r => {
            r = r.data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      } else {
        this.loading = true;
        this.loadingText = '保存中...';
        update(this.ruleForm)
          .then(r => {
            r = r.data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
          //  this.$emit("ChangeTab", "second"); //返回上一层
          this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    }
  }
};
</script>